import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { BarLoader, PuffLoader } from "react-spinners";

const Loading = ({ active, timeout, size, spinner, css }) => {
  const [loading, setLoading] = useState(active);

  useEffect(() => {
    if (timeout) setTimeout(() => setLoading(false), timeout || 1000);
  }, [timeout]);

  return (
    <div className={`-loading ${loading && "-active"}`}>
      {spinner ? (
        <PuffLoader size={size} color="#50accb" loading={loading} css={css} />
      ) : (
        <BarLoader
          sizeUnit="px"
          size={size}
          color="#50accb"
          loading={loading}
          css={css}
        />
      )}
    </div>
  );
};

Loading.propTypes = {
  active: PropTypes.bool,
  size: PropTypes.number,
  timeout: PropTypes.number,
  spinner: PropTypes.bool,
  css: PropTypes.object
};
Loading.defaultProps = {
  size: 150,
  css: null
};
export default Loading;
